import { useRouteError } from 'react-router-dom'

export default function ErrorPage() {
  const error = useRouteError()

  let errorToDisplay = ''

  if (error instanceof Error) {
    errorToDisplay = error.message
  }

  console.error(error)

  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{errorToDisplay}</i>
      </p>
    </div>
  )
}
